import { createDom, format, getBuffered2 } from 'xgplayer/src/utils/util'
import '../style/controls/memoryPlay.scss'
import closeBtn from '../assets/close-btn.svg'

let s_memoryPlay = function() {
  let player = this
  let lastPlayTime = player.config.lastPlayTime || 0
  let lastPlayTimeHideDelay = player.config.lastPlayTimeHideDelay || 0
  let dom = null

  if (lastPlayTime <= 0) {
    return
  }
  dom = createDom(
    'xg-memoryplay',
    `<div class="xgplayer-memoryplay-spot">
      <div class="xgplayer-progress-tip">
      <div class="btn-close" >${closeBtn} </div>
      上次看到
         <span class="xgplayer-lasttime">${format(lastPlayTime)}</span>
        <span class="jump-memo-link"> &nbsp跳转</span>
      </div>
     </div>`,
    {},
    'xgplayer-memoryplay'
  )
  dom.addEventListener('mouseover', e => {
    e.stopPropagation()
  })
  const removeFunc = () => {
    dom && dom.parentNode && dom.parentNode.removeChild(dom)
    dom = null
  }
  const handleMemoPlay = () => {
    player.emit('memoryPlayStart', lastPlayTime)
    removeFunc()
  }
  dom.querySelector('.xgplayer-progress-tip .jump-memo-link').addEventListener('click', handleMemoPlay)
  dom.querySelector('.xgplayer-progress-tip .btn-close').addEventListener('click', removeFunc)

  const handlePlay = () => {
    if (lastPlayTimeHideDelay > 0) {
      player.root.appendChild(dom)

      setTimeout(() => {
        removeFunc()
      }, lastPlayTimeHideDelay * 1000)
    }
  }
  player.once('play', handlePlay)
  player.once('ended', removeFunc)
}

export default {
  name: 's_memoryPlay',
  method: s_memoryPlay
}
